// Molecular: Cache management for energy data

// Cache TTL in milliseconds (1 hour)
const CACHE_TTL = 60 * 60 * 1000;

// Cache for storing loaded data
export const dataCache: Record<string, unknown> = {};

// Cache for Gemeinde data
export const gemeindenCache: Array<Record<string, unknown>> = [];

// Cache for PLZ mapping
export const plzMappingCache: Record<string, unknown> = {};

/**
 * Clear expired cache entries
 */
export function clearExpiredCache(): void {
  if (typeof window === 'undefined') return;
  
  try {
    const now = new Date().getTime();
    Object.keys(localStorage).forEach(key => {
      if (key.endsWith('_timestamp')) {
        const timestamp = parseInt(localStorage.getItem(key) || '0', 10);
        if (now - timestamp > CACHE_TTL) {
          const dataKey = key.replace('_timestamp', '');
          localStorage.removeItem(dataKey);
          localStorage.removeItem(key);
        }
      }
    });
  } catch (error) {
    console.error('Error clearing expired cache:', error);
  }
}

// Initialize cache cleanup
if (typeof window !== 'undefined') {
  clearExpiredCache();
}
